import { render, staticRenderFns } from "./OiseauAnimation.vue?vue&type=template&id=2bc1f245&scoped=true&"
import script from "./OiseauAnimation.js?vue&type=script&lang=js&"
export * from "./OiseauAnimation.js?vue&type=script&lang=js&"
import style0 from "./OiseauAnimation.scoped.scss?vue&type=style&index=0&id=2bc1f245&lang=scss&scoped=true&"
import style1 from "./OiseauAnimation.scss?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bc1f245",
  null
  
)

export default component.exports